export const LABEL_SPECIFIC_VOLUME = "specificVolume";
export const LABEL_EQUAL_PERCENTAGES = "equalPercentages";
export const LABEL_GROUP = "group";
export const LABEL_INDIVIDUAL = "individual";
export const LABEL_SPECIFIC_COUNT = "Case Count";
export const LABEL_SPECIFIC_PERCENTAGE = "Percentages";
export const LABEL_INCOMING_CASES = "incomingCases";
export const LABEL_CODED_CASES = "codedCases";
export const LABEL_IMPORTED_DATA = "importedData";
export const LABEL_TYPE_WORK_QUEUE = "typeWorkQueue";
export const LABEL_TYPE_WORK_PROJECT = "typeWorkProject";
export const LABEL_TYPE_WORK_PROJECT_COMPARE = "typeWorkProjectCompare";